<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <sw-panel class="modal-font">
      <span class="flex center font-modal-title">Choisissez la plus belle des polices</span>
      <div class="flex wrapper-font-form s-center">
        <div>
          <div class="font-select" :class="{ 'font-select--open': isOpen }" :style="{ minWidth: dropdownWidth }" v-click-outside="closeDropdown">
            <div class="font-select__trigger" @click="isOpen = !isOpen">
              <span class="font-select__label" :style="previewFont">
                {{ selectedFont.label }}
              </span>
              <svg
                class="font-select__arrow"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>

            <transition name="dropdown">
              <div v-if="isOpen" class="font-select__dropdown">
                <div
                  v-for="(font, index) in fontList"
                  :key="index"
                  class="font-select__option"
                  :class="{ 'font-select__option--active': selectedFont.label === font.label }"
                  :style="font.style"
                  @click="selectFont(font)"
                >
                  {{ font.label }}
                </div>
              </div>
            </transition>
          </div>
        </div>
        <sw-button label="valider" @click="validFont" class="button-font-valid center full" />
      </div>
    </sw-panel>
  </sw-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FontModal',
  directives: {
    'click-outside': {
      bind(el, binding) {
        el._outsideHandler = function(e) {
          if (!el.contains(e.target)) binding.value()
        }
        document.addEventListener('click', el._outsideHandler)
      },
      unbind(el) {
        document.removeEventListener('click', el._outsideHandler)
      }
    }
  },
  data() {
    return {
      isOpen: false,
      fontList: [],
      dropdownWidth: 'auto',
      selectedFont: { label: 'Select font', fontFamily: 'Roboto', style: 'font-family:Roboto;' }
    }
  },
  computed: {
    ...mapGetters(['getColorList', 'getFontsList', 'getCurrentColor', 'getFontFormat']),
    previewFont() {
      return this.selectedFont.style
    }
  },
  mounted() {
    this.initFont()
    this.initFontList()
    this.$nextTick(() => {
      this.calcMaxWidth()
    })
  },
  methods: {
    ...mapActions(['updateCurrentColor']),
    initFont() {
      if (this.getFontFormat && this.getFontFormat.label) {
        this.selectedFont = {
          label: this.getFontFormat.label,
          fontFamily: this.getFontFormat.fontFamily,
          style: 'font-family:' + this.getFontFormat.fontFamily
        }
      }
    },
    initFontList() {
      if (this.getFontsList && this.getFontsList.length) {
        this.fontList = this.getFontsList.map(item => {
          const ff = item.fontFamily ? item.fontFamily : item.label
          return {
            label: item.label,
            value: item,
            style: `font-family: ${ff};`
          }
        })
      }
    },
    closeDropdown() {
      this.isOpen = false
    },
    calcMaxWidth() {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      const padding = 60
      let maxWidth = 0

      this.fontList.forEach(font => {
        const ff = font.label
        ctx.font = '16px ' + ff
        const width = ctx.measureText(font.label).width
        if (width > maxWidth) maxWidth = width
      })

      this.dropdownWidth = Math.ceil(maxWidth + padding) + 'px'
    },
    selectFont(font) {
      const fontItem = this.getFontsList.find(f => f.label === font.label)
      const fontFamily = fontItem.fontFamily ? fontItem.fontFamily : font.label
      this.selectedFont = {
        label: font.label,
        fontFamily,
        style: 'font-family:' + fontFamily + ';'
      }
      this.isOpen = false
    },
    validFont() {
      this.$emit('selectFont', this.selectedFont.fontFamily)
    }
  },
  watch: {
    getFontFormat: {
      immediate: true,
      handler(val) {
        if (val && val.label) {
          this.initFont()
        }
      }
    },
    getFontsList: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.initFontList()
          this.$nextTick(() => {
            this.calcMaxWidth()
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.font-select {
  position: relative;
  user-select: none;
}

.font-select__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 16px;
  background: var(--surface, #fff);
  border: 1.5px solid var(--border, #ddd);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.font-select__trigger:hover {
  border-color: var(--border-hover, #bbb);
}

.font-select--open .font-select__trigger {
  border-color: var(--action-color);
  box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.15);
}

.font-select__label {
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.font-select__arrow {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-left: 10px;
  transition: transform 0.3s ease;
  color: #999;
}

.font-select--open .font-select__arrow {
  transform: rotate(180deg);
  color: var(--action-color);
}

.font-select__dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: var(--surface, #fff);
  border: 1.5px solid var(--border, #ddd);
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  max-height: 250px;
  overflow-y: auto;
  z-index: 100;
  padding: 4px;
}

.font-select__dropdown::-webkit-scrollbar {
  width: 5px;
}
.font-select__dropdown::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.font-select__option {
  padding: 10px 14px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background 0.15s ease;
  font-size: 1rem;
  white-space: nowrap;
}

.font-select__option:hover {
  background: rgba(0, 0, 0, 0.05);
}

.font-select__option--active {
  background: rgba(108, 92, 231, 0.1);
}

.font-select__option--active::after {
  content: '✓';
  font-size: 0.75rem;
  color: var(--action-color);
  font-weight: 600;
}

.dropdown-enter-active {
  animation: dropIn 0.2s ease;
}
.dropdown-leave-active {
  animation: dropIn 0.15s ease reverse;
}

@keyframes dropIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/FontModal.vue